import { useQuery } from '@tanstack/react-query';
import API from '../../../utils/api';

export const useOPMTransferClabe = () => {
  return useQuery(
    ['/opm-transfer-clabe'],
    async () => (await API.getOPMTransferAccount())?.data || {}
  );
};
